import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
// import { Auth, applyActionCode } from '@angular/fire/auth';


@Injectable({
  providedIn: 'root'
})
export class RedirectFbService {

  private params: any;
  private error: Subject<string> = new Subject();

  get getError(): Observable<string> {
    return this.error.asObservable();
  }

  constructor(
    private af: AngularFireAuth,
    // private authFirebase: Auth
  ) { }

  validMail(): void {
    this.af.applyActionCode(this.params.oobCode);

  }

  
  // validMail2(): void {


  //   applyActionCode(this.authFirebase, this.params.oobCode).then((value: any) => {
  //   
  //   })
  // }



  resetPassword(newPassword: any): Promise<any> {
    const that = this;

    return new Promise((resolve) => {

      that.af.verifyPasswordResetCode(that.params.oobCode).then(function (email: any) {

        that.af.confirmPasswordReset(that.params.oobCode, newPassword).then(function (resp: any) {
          that.error.next("success");
          resolve(null);
        })

      }).catch(function (err: any) {

        if (err.code === "auth/invalid-action-code") {
          that.error.next("errlink");
        }

        resolve(null);
      });

    })




  }

  setParams(params: any) {
    this.params = params;
  }

  parseEmail(): string {
    return this.params.continueUrl.split("=")[1];
  }
}
